import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';

// Layout components
import Layout from './components/Layout/Layout';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';

// Page components
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import FoodDetailPage from './pages/FoodDetailPage';
import FreeFoodsPage from './pages/FreeFoodsPage';
import AddFoodPage from './pages/AddFoodPage';
import AboutPage from './pages/AboutPage';
import AllEntriesPage from './pages/AllEntriesPage';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Layout>
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/food/:id" element={<FoodDetailPage />} />
                <Route path="/free-foods" element={<FreeFoodsPage />} />
                <Route path="/add-food" element={<AddFoodPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/debug/all-entries" element={<AllEntriesPage />} />
              </Routes>
            </main>
            <Footer />
          </Layout>
        </div>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#22c55e',
                secondary: '#fff',
              },
            },
            error: {
              duration: 5000,
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </Router>
    </QueryClientProvider>
  );
}

export default App;
